<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-lines-deliverynotes-received',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },

  computed: {
    ...mapGetters([
      'isShowItemCodeLinesDeliveryNoteReceived',
      'isShowItemCodeSellerLinesDeliveryNoteReceived',
      'isShowItemCodeBuyerLinesDeliveryNoteReceived',
      'isShowCodeCentreDeliveryPointLinesDeliveryNoteReceived',
      'isShowDescriptionLinesDeliveryNoteReceived',
      'isShowOrderLinesDeliveryNoteReceived',
      'isShowStatusLinesDeliveryNoteReceived',
      'isShowQuantityLinesDeliveryNoteReceived',
      'isShowMeasureLinesDeliveryNoteReceived',
      'isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceived',
      'isShowQuantityTradeUnitLinesDeliveryNoteReceived',
      'isShowSerialNumberLinesDeliveryNoteReceived',
      'isShowExpirationDateLinesDeliveryNoteReceived',
      'isShowBatchLinesDeliveryNoteReceived',
      'isShowGtin14LinesDeliveryNoteReceived'
    ])
  },

  methods: {
    ...mapActions([
      'isShowItemCodeLinesDeliveryNoteReceivedAction',
      'isShowItemCodeSellerLinesDeliveryNoteReceivedAction',
      'isShowItemCodeBuyerLinesDeliveryNoteReceivedAction',
      'isShowCodeCentreDeliveryPointLinesDeliveryNoteReceivedAction',
      'isShowDescriptionLinesDeliveryNoteReceivedAction',
      'isShowOrderLinesDeliveryNoteReceivedAction',
      'isShowStatusLinesDeliveryNoteReceivedAction',
      'isShowQuantityLinesDeliveryNoteReceivedAction',
      'isShowMeasureLinesDeliveryNoteReceivedAction',
      'isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceivedAction',
      'isShowQuantityTradeUnitLinesDeliveryNoteReceivedAction',
      'isShowSerialNumberLinesDeliveryNoteReceivedAction',
      'isShowExpirationDateLinesDeliveryNoteReceivedAction',
      'isShowBatchLinesDeliveryNoteReceivedAction',
      'isShowGtin14LinesDeliveryNoteReceivedAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'itemCode':
          isShow = !this.isShowItemCodeLinesDeliveryNoteReceived
          this.isShowItemCodeLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'itemCodeSeller':
          isShow = !this.isShowItemCodeSellerLinesDeliveryNoteReceived
          this.isShowItemCodeSellerLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'itemCodeBuyer':
          isShow = !this.isShowItemCodeBuyerLinesDeliveryNoteReceived
          this.isShowItemCodeBuyerLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'codeCentreDeliveryPoint':
          isShow = !this.isShowCodeCentreDeliveryPointLinesDeliveryNoteReceived
          this.isShowCodeCentreDeliveryPointLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'description':
          isShow = !this.isShowDescriptionLinesDeliveryNoteReceived
          this.isShowDescriptionLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'order':
          isShow = !this.isShowOrderLinesDeliveryNoteReceived
          this.isShowOrderLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'status':
          isShow = !this.isShowStatusLinesDeliveryNoteReceived
          this.isShowStatusLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'quantity':
          isShow = !this.isShowQuantityLinesDeliveryNoteReceived
          this.isShowQuantityLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'measure':
          isShow = !this.isShowMeasureLinesDeliveryNoteReceived
          this.isShowMeasureLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'quantityTradeUnit':
          isShow = !this.isShowQuantityTradeUnitLinesDeliveryNoteReceived
          this.isShowQuantityTradeUnitLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'unitOfMeasureTradeUnit':
          isShow = !this.isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceived
          this.isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'serialNumber':
          isShow = !this.isShowSerialNumberLinesDeliveryNoteReceived
          this.isShowSerialNumberLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'batch':
          isShow = !this.isShowBatchLinesDeliveryNoteReceived
          this.isShowBatchLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'expirationDate':
          isShow = !this.isShowExpirationDateLinesDeliveryNoteReceived
          this.isShowExpirationDateLinesDeliveryNoteReceivedAction(isShow)
          break
        case 'gtin14Code':
          isShow = !this.isShowGtin14LinesDeliveryNoteReceived
          this.isShowGtin14LinesDeliveryNoteReceivedAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('deliverynote.delivery_entity_table_detail.itemCode'), value: 'itemCode', show: this.isShowItemCodeLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.itemCodeSeller'), value: 'itemCodeSeller', show: this.isShowItemCodeSellerLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.itemCodeBuyer'), value: 'itemCodeBuyer', show: this.isShowItemCodeBuyerLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.gtin14Code'), value: 'gtin14Code', show: this.isShowGtin14LinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.codeCentreDeliveryPoint'), value: 'codeCentreDeliveryPoint', show: this.isShowCodeCentreDeliveryPointLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.description'), value: 'description', show: this.isShowDescriptionLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.order'), value: 'order', show: this.isShowOrderLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.serialNumber'), value: 'serialNumber', show: this.isShowSerialNumberLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.batch'), value: 'batch', show: this.isShowBatchLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.expirationDate'), value: 'expirationDate', show: this.isShowExpirationDateLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.quantity'), value: 'quantity', show: this.isShowQuantityLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.quantityTradeUnit'), value: 'quantityTradeUnit', show: this.isShowQuantityTradeUnitLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.measure'), value: 'measure', show: this.isShowMeasureLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.measureTradeUnit'), value: 'unitOfMeasureTradeUnit', show: this.isShowUnitOfMeasureTradeUnitLinesDeliveryNoteReceived
        }, {
          text: this.$t('deliverynote.delivery_entity_table_detail.status'), value: 'status', show: this.isShowStatusLinesDeliveryNoteReceived
        }
      ]
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
